<template>
  <!-- incentivo por nivel de valor (ex.: Sempre Presente com Voce): so a rede do distribuidor -->
  <div class="nivel">
    <div class="row">
      <!-- esquerda: regra, meu progresso e niveis -->
      <div class="col-lg-4 mb-3 mb-lg-0">
        <p class="nivel-regra">
          O nível é definido pelo <b>valor total faturado</b> de {{ periodo }}<template v-if="dados.meses_minimo">,
          com faturamento em pelo menos <b>{{ dados.meses_minimo }}</b> dos {{ dados.meses.length }} meses</template>.
        </p>

        <div v-if="meu" class="nivel-meu" :class="'nivel-meu--' + meu.estado">
          <div class="nivel-meu-topo">
            <span class="nivel-meu-rotulo">Seu progresso</span>
            <span class="nivel-selo" :class="'nivel-selo--' + meu.nivel">{{ meu.nivel ? 'Nível ' + meu.nivel : 'Sem nível' }}</span>
          </div>
          <div class="nivel-meu-total">{{ moeda(meu.valor_total) }}</div>
          <div class="nivel-barra nivel-barra--grande">
            <div class="nivel-barra-cheia" :class="'nivel-fundo--' + meu.nivel" :style="{ width: pct(meu.valor_total) + '%' }"></div>
            <span
              v-for="(n, i) in dados.niveis"
              :key="i"
              class="nivel-marca"
              :style="{ left: pct(n.total) + '%' }"
              :title="n.nome + ': ' + moeda(n.total)"
            ></span>
          </div>
          <div class="nivel-meses">
            <span v-for="(mes, i) in dados.meses" :key="mes" class="nivel-mes" :class="{ 'nivel-mes--ok': (meu.valores_mes[i] || 0) > 0 }">
              {{ mes }} <b>{{ moeda(meu.valores_mes[i] || 0) }}</b>
            </span>
          </div>
          <div v-if="meu.brinde"><i class="fas fa-gift mr-1"></i>{{ meu.brinde }}</div>
          <small class="d-block text-muted">{{ meu.proximo || meu.situacao }}</small>
        </div>

        <div class="nivel-niveis">
          <div class="nivel-niveis-titulo">Níveis</div>
          <div v-for="(n, i) in dados.niveis" :key="i" class="nivel-item" :class="'nivel-borda--' + (i + 1)">
            <div class="nivel-item-topo">
              <span class="nivel-item-nome">{{ n.nome }}</span>
              <span class="nivel-item-valor">{{ moeda(n.total) }}</span>
            </div>
            <div class="nivel-item-brinde">{{ n.brinde }}</div>
            <div v-if="dados.rede.length" class="nivel-item-qtd">
              <b>{{ porNivel[i + 1] || 0 }}</b> da sua rede
            </div>
          </div>
        </div>
      </div>

      <!-- direita: revendedoras da rede -->
      <div class="col-lg-8">
        <template v-if="dados.rede.length">
          <div class="nivel-resumo">
            <button
              v-for="f in filtros"
              :key="f.chave"
              type="button"
              class="nivel-filtro"
              :class="['nivel-filtro--' + f.chave, { 'nivel-filtro--ativo': filtro === f.chave }]"
              @click="filtro = f.chave"
            >
              {{ f.rotulo }} <b>{{ f.qtd }}</b>
            </button>
            <b-form-input v-model="busca" size="sm" class="nivel-busca" placeholder="Buscar revendedora ou cidade" />
          </div>

          <div class="nivel-lista">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th>Revendedora</th>
                  <th v-for="mes in dados.meses" :key="mes" class="text-right d-none d-lg-table-cell">{{ mes }}</th>
                  <th class="text-right">Total</th>
                  <th>Nível / próximo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in redeFiltrada" :key="item.id">
                  <td>
                    <div class="nivel-nome">{{ item.nome }}</div>
                    <small class="text-muted">{{ item.cidade }}/{{ item.uf }}</small>
                  </td>
                  <td
                    v-for="(mes, i) in dados.meses"
                    :key="mes"
                    class="text-right d-none d-lg-table-cell nivel-valor-mes"
                    :class="{ 'text-muted': !(item.valores_mes[i] > 0) }"
                  >{{ moeda(item.valores_mes[i] || 0) }}</td>
                  <td class="text-right nivel-total">
                    <b>{{ moeda(item.valor_total) }}</b>
                    <div class="nivel-barra">
                      <div class="nivel-barra-cheia" :class="'nivel-fundo--' + item.nivel" :style="{ width: pct(item.valor_total) + '%' }"></div>
                    </div>
                  </td>
                  <td>
                    <span class="nivel-selo" :class="'nivel-selo--' + item.nivel">{{ item.nivel ? 'Nível ' + item.nivel : semNivel(item) }}</span>
                    <small v-if="item.brinde" class="nivel-brinde">{{ item.brinde }}</small>
                    <small class="d-block text-muted">{{ item.nivel ? item.proximo : item.situacao }}</small>
                  </td>
                </tr>
                <tr v-if="!redeFiltrada.length">
                  <td :colspan="dados.meses.length + 3" class="text-center text-muted py-3">Nenhuma revendedora encontrada.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <p v-else class="text-muted">Nenhuma revendedora da sua rede participando ainda.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dados: { type: Object, required: true },
  },
  data() {
    return {
      busca: "",
      filtro: "todas",
    };
  },
  computed: {
    meu() {
      return this.dados.meu;
    },
    periodo() {
      const m = this.dados.meses;
      if (!m.length) return "toda a campanha";
      return m.length === 1 ? m[0] : m[0] + " a " + m[m.length - 1];
    },
    // escala das barras: o total do ultimo nivel
    escala() {
      const n = this.dados.niveis;
      return n.length ? n[n.length - 1].total : 0;
    },
    porNivel() {
      const cont = {};
      this.dados.rede.forEach((i) => {
        if (i.nivel) cont[i.nivel] = (cont[i.nivel] || 0) + 1;
      });
      return cont;
    },
    filtros() {
      const conta = (estado) => this.dados.rede.filter((i) => i.estado === estado).length;
      return [
        { chave: "todas", rotulo: "Todas", qtd: this.dados.rede.length },
        { chave: "premiada", rotulo: "Premiadas", qtd: conta("premiada") },
        { chave: "risco", rotulo: "Em risco", qtd: conta("risco") },
        { chave: "fora", rotulo: "Fora", qtd: conta("fora") },
      ];
    },
    redeFiltrada() {
      const termo = this.normaliza(this.busca);
      return this.dados.rede.filter(
        (item) =>
          (this.filtro === "todas" || item.estado === this.filtro) &&
          (!termo || this.normaliza(item.nome + " " + item.cidade + " " + item.uf).includes(termo))
      );
    },
  },
  methods: {
    moeda(valor) {
      return (valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    pct(valor) {
      if (!this.escala) return 0;
      return Math.min(100, Math.round(((valor || 0) / this.escala) * 1000) / 10);
    },
    semNivel(item) {
      return item.estado === "risco" ? "Em risco" : "Sem nível";
    },
    normaliza(texto) {
      return (texto || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .trim();
    },
  },
};
</script>

<style scoped>
.nivel-regra {
  margin-bottom: 14px;
  color: #495057;
}

/* meu progresso */
.nivel-meu {
  padding: 14px 18px;
  margin-bottom: 20px;
  border-radius: 6px;
  border-left: 5px solid #6c757d;
  background: #f4f5f7;
}
.nivel-meu--premiada {
  border-left-color: #28a745;
  background: #eef8f0;
}
.nivel-meu--risco {
  border-left-color: #e0a800;
  background: #fdf8ea;
}
.nivel-meu-topo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nivel-meu-rotulo {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #6c757d;
}
.nivel-meu-total {
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.2;
  margin: 4px 0 8px;
}
.nivel-meses {
  margin: 10px 0 6px;
}
.nivel-mes {
  display: inline-block;
  margin: 0 6px 4px 0;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  background: #fff;
  border: 1px solid #d6dbe1;
}
.nivel-mes--ok {
  color: #1e7e34;
  border-color: #9fd5ab;
  background: #f1faf3;
}

/* barras */
.nivel-barra {
  position: relative;
  height: 5px;
  margin-top: 4px;
  border-radius: 3px;
  background: #e9ecef;
}
.nivel-barra--grande {
  height: 10px;
  border-radius: 5px;
}
.nivel-barra-cheia {
  height: 100%;
  border-radius: inherit;
  background: #9aa3ad;
}
.nivel-marca {
  position: absolute;
  top: -3px;
  bottom: -3px;
  width: 2px;
  margin-left: -1px;
  background: #495057;
  opacity: 0.45;
}

/* selos e cores por nivel */
.nivel-selo {
  display: inline-block;
  padding: 1px 10px;
  border-radius: 12px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #fff;
  background: #9aa3ad;
  white-space: nowrap;
}
.nivel-selo--1,
.nivel-fundo--1 { background: #5cb85c; }
.nivel-selo--2,
.nivel-fundo--2 { background: #6a8cb5; }
.nivel-selo--3,
.nivel-fundo--3 { background: #8a6fb0; }
.nivel-selo--4,
.nivel-fundo--4 { background: #d4a72c; }
.nivel-borda--1 { border-left-color: #5cb85c !important; }
.nivel-borda--2 { border-left-color: #6a8cb5 !important; }
.nivel-borda--3 { border-left-color: #8a6fb0 !important; }
.nivel-borda--4 { border-left-color: #d4a72c !important; }

/* lista de niveis */
.nivel-niveis {
  border: 1px solid #edf0f3;
  border-radius: 6px;
  overflow: hidden;
}
.nivel-niveis-titulo {
  padding: 6px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6c757d;
  background: #f8f9fa;
}
.nivel-item {
  padding: 8px 12px;
  border-left: 5px solid;
  border-top: 1px solid #edf0f3;
}
.nivel-item-topo {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}
.nivel-item-brinde {
  font-size: 0.85rem;
  color: #495057;
}
.nivel-item-qtd {
  font-size: 0.8rem;
  color: #6c757d;
}

/* filtros e lista da rede */
.nivel-resumo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.nivel-filtro {
  padding: 3px 12px;
  border: 1px solid #dee2e6;
  border-radius: 14px;
  background: #fff;
  font-size: 0.85rem;
  color: #495057;
  cursor: pointer;
}
.nivel-filtro--ativo {
  border-color: #4f6f96;
  background: #4f6f96;
  color: #fff;
}
.nivel-filtro--premiada.nivel-filtro--ativo {
  border-color: #28a745;
  background: #28a745;
}
.nivel-filtro--risco.nivel-filtro--ativo {
  border-color: #e0a800;
  background: #e0a800;
}
.nivel-busca {
  max-width: 260px;
  margin-left: auto;
}
.nivel-lista {
  max-height: 560px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 4px;
}
.nivel-lista thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8f9fa;
  border-top: 0;
}
.nivel-nome {
  font-weight: 600;
}
.nivel-valor-mes {
  white-space: nowrap;
  font-size: 0.85rem;
}
.nivel-total {
  min-width: 110px;
  white-space: nowrap;
}
.nivel-brinde {
  margin-left: 6px;
}

@media (max-width: 576px) {
  .nivel-busca {
    max-width: none;
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/Home/NivelHome.vue